import { plural } from '@cian/utils';

export function getGuestsLabel(value: number): string {
  return `${value} ${plural(value, ['гость', 'гостя', 'гостей'])}`;
}
